module.exports = __webpack_public_path__ + "static/circle-2-ab9a5d2989310f5f82d9df5aecbae54e.svg";